import axios from "axios";

const countriesWithCurrencies = [
  { code: "AF", name: "Afghanistan", currency: "AFN" },
  { code: "AL", name: "Albania", currency: "ALL" },
  { code: "DZ", name: "Algeria", currency: "DZD" },
  { code: "AD", name: "Andorra", currency: "EUR" },
  { code: "AO", name: "Angola", currency: "AOA" },
  { code: "AG", name: "Antigua and Barbuda", currency: "XCD" },
  { code: "AR", name: "Argentina", currency: "ARS" },
  { code: "AM", name: "Armenia", currency: "AMD" },
  { code: "AU", name: "Australia", currency: "AUD" },
  { code: "AT", name: "Austria", currency: "EUR" },
  { code: "AZ", name: "Azerbaijan", currency: "AZN" },
  { code: "BS", name: "Bahamas", currency: "BSD" },
  { code: "BH", name: "Bahrain", currency: "BHD" },
  { code: "BD", name: "Bangladesh", currency: "BDT" },
  { code: "BB", name: "Barbados", currency: "BBD" },
  { code: "BY", name: "Belarus", currency: "BYN" },
  { code: "BE", name: "Belgium", currency: "EUR" },
  { code: "BZ", name: "Belize", currency: "BZD" },
  { code: "BJ", name: "Benin", currency: "XOF" },
  { code: "BT", name: "Bhutan", currency: "BTN" },
  { code: "BO", name: "Bolivia", currency: "BOB" },
  { code: "BA", name: "Bosnia and Herzegovina", currency: "BAM" },
  { code: "BW", name: "Botswana", currency: "BWP" },
  { code: "BR", name: "Brazil", currency: "BRL" },
  { code: "BN", name: "Brunei", currency: "BND" },
  { code: "BG", name: "Bulgaria", currency: "BGN" },
  { code: "BF", name: "Burkina Faso", currency: "XOF" },
  { code: "BI", name: "Burundi", currency: "BIF" },
  { code: "CV", name: "Cabo Verde", currency: "CVE" },
  { code: "KH", name: "Cambodia", currency: "KHR" },
  { code: "CM", name: "Cameroon", currency: "XAF" },
  { code: "CA", name: "Canada", currency: "CAD" },
  { code: "CF", name: "Central African Republic", currency: "XAF" },
  { code: "TD", name: "Chad", currency: "XAF" },
  { code: "CL", name: "Chile", currency: "CLP" },
  { code: "CN", name: "China", currency: "CNY" },
  { code: "CO", name: "Colombia", currency: "COP" },
  { code: "KM", name: "Comoros", currency: "KMF" },
  { code: "CG", name: "Congo (Congo-Brazzaville)", currency: "XAF" },
  { code: "CR", name: "Costa Rica", currency: "CRC" },
  { code: "HR", name: "Croatia", currency: "HRK" },
  { code: "CU", name: "Cuba", currency: "CUP" },
  { code: "CY", name: "Cyprus", currency: "EUR" },
  { code: "CZ", name: "Czech Republic", currency: "CZK" },
  { code: "CD", name: "Democratic Republic of the Congo", currency: "CDF" },
  { code: "DK", name: "Denmark", currency: "DKK" },
  { code: "DJ", name: "Djibouti", currency: "DJF" },
  { code: "DM", name: "Dominica", currency: "XCD" },
  { code: "DO", name: "Dominican Republic", currency: "DOP" },
  { code: "EC", name: "Ecuador", currency: "USD" },
  { code: "EG", name: "Egypt", currency: "EGP" },
  { code: "SV", name: "El Salvador", currency: "USD" },
  { code: "GQ", name: "Equatorial Guinea", currency: "XAF" },
  { code: "ER", name: "Eritrea", currency: "ERN" },
  { code: "EE", name: "Estonia", currency: "EUR" },
  { code: "SZ", name: "Eswatini", currency: "SZL" },
  { code: "ET", name: "Ethiopia", currency: "ETB" },
  { code: "FJ", name: "Fiji", currency: "FJD" },
  { code: "FI", name: "Finland", currency: "EUR" },
  { code: "FR", name: "France", currency: "EUR" },
  { code: "GA", name: "Gabon", currency: "XAF" },
  { code: "GM", name: "Gambia", currency: "GMD" },
  { code: "GE", name: "Georgia", currency: "GEL" },
  { code: "DE", name: "Germany", currency: "EUR" },
  { code: "GH", name: "Ghana", currency: "GHS" },
  { code: "GR", name: "Greece", currency: "EUR" },
  { code: "GD", name: "Grenada", currency: "XCD" },
  { code: "GT", name: "Guatemala", currency: "GTQ" },
  { code: "GN", name: "Guinea", currency: "GNF" },
  { code: "GW", name: "Guinea-Bissau", currency: "XOF" },
  { code: "GY", name: "Guyana", currency: "GYD" },
  { code: "HT", name: "Haiti", currency: "HTG" },
  { code: "HN", name: "Honduras", currency: "HNL" },
  { code: "HU", name: "Hungary", currency: "HUF" },
  { code: "IS", name: "Iceland", currency: "ISK" },
  { code: "IN", name: "India", currency: "INR" },
  { code: "ID", name: "Indonesia", currency: "IDR" },
  { code: "IR", name: "Iran", currency: "IRR" },
  { code: "IQ", name: "Iraq", currency: "IQD" },
  { code: "IE", name: "Ireland", currency: "EUR" },
  { code: "IL", name: "Israel", currency: "ILS" },
  { code: "IT", name: "Italy", currency: "EUR" },
  { code: "JM", name: "Jamaica", currency: "JMD" },
  { code: "JP", name: "Japan", currency: "JPY" },
  { code: "JO", name: "Jordan", currency: "JOD" },
  { code: "KZ", name: "Kazakhstan", currency: "KZT" },
  { code: "KE", name: "Kenya", currency: "KES" },
  { code: "KI", name: "Kiribati", currency: "AUD" },
  { code: "KP", name: "Korea, North", currency: "KPW" },
  { code: "KR", name: "Korea, South", currency: "KRW" },
  { code: "XK", name: "Kosovo", currency: "EUR" },
  { code: "KW", name: "Kuwait", currency: "KWD" },
  { code: "KG", name: "Kyrgyzstan", currency: "KGS" },
  { code: "LA", name: "Laos", currency: "LAK" },
  { code: "LV", name: "Latvia", currency: "EUR" },
  { code: "LB", name: "Lebanon", currency: "LBP" },
  { code: "LS", name: "Lesotho", currency: "LSL" },
  { code: "LR", name: "Liberia", currency: "LRD" },
  { code: "LY", name: "Libya", currency: "LYD" },
  { code: "LI", name: "Liechtenstein", currency: "CHF" },
  { code: "LT", name: "Lithuania", currency: "EUR" },
  { code: "LU", name: "Luxembourg", currency: "EUR" },
  { code: "MG", name: "Madagascar", currency: "MGA" },
  { code: "MW", name: "Malawi", currency: "MWK" },
  { code: "MY", name: "Malaysia", currency: "MYR" },
  { code: "MV", name: "Maldives", currency: "MVR" },
  { code: "ML", name: "Mali", currency: "XOF" },
  { code: "MT", name: "Malta", currency: "EUR" },
  { code: "MH", name: "Marshall Islands", currency: "USD" },
  { code: "MR", name: "Mauritania", currency: "MRU" },
  { code: "MU", name: "Mauritius", currency: "MUR" },
  { code: "MX", name: "Mexico", currency: "MXN" },
  { code: "FM", name: "Micronesia", currency: "USD" },
  { code: "MD", name: "Moldova", currency: "MDL" },
  { code: "MC", name: "Monaco", currency: "EUR" },
  { code: "MN", name: "Mongolia", currency: "MNT" },
  { code: "ME", name: "Montenegro", currency: "EUR" },
  { code: "MA", name: "Morocco", currency: "MAD" },
  { code: "MZ", name: "Mozambique", currency: "MZN" },
  { code: "MM", name: "Myanmar", currency: "MMK" },
  { code: "NA", name: "Namibia", currency: "NAD" },
  { code: "NR", name: "Nauru", currency: "AUD" },
  { code: "NP", name: "Nepal", currency: "NPR" },
  { code: "NL", name: "Netherlands", currency: "EUR" },
  { code: "NZ", name: "New Zealand", currency: "NZD" },
  { code: "NI", name: "Nicaragua", currency: "NIO" },
  { code: "NE", name: "Niger", currency: "XOF" },
  { code: "NG", name: "Nigeria", currency: "NGN" },
  { code: "MK", name: "North Macedonia", currency: "MKD" },
  { code: "NO", name: "Norway", currency: "NOK" },
  { code: "OM", name: "Oman", currency: "OMR" },
  { code: "PK", name: "Pakistan", currency: "PKR" },
  { code: "PW", name: "Palau", currency: "USD" },
  { code: "PA", name: "Panama", currency: "PAB" },
  { code: "PG", name: "Papua New Guinea", currency: "PGK" },
  { code: "PY", name: "Paraguay", currency: "PYG" },
  { code: "PE", name: "Peru", currency: "PEN" },
  { code: "PH", name: "Philippines", currency: "PHP" },
  { code: "PL", name: "Poland", currency: "PLN" },
  { code: "PT", name: "Portugal", currency: "EUR" },
  { code: "QA", name: "Qatar", currency: "QAR" },
  { code: "RO", name: "Romania", currency: "RON" },
  { code: "RU", name: "Russia", currency: "RUB" },
  { code: "RW", name: "Rwanda", currency: "RWF" },
  { code: "KN", name: "Saint Kitts and Nevis", currency: "XCD" },
  { code: "LC", name: "Saint Lucia", currency: "XCD" },
  { code: "VC", name: "Saint Vincent and the Grenadines", currency: "XCD" },
  { code: "WS", name: "Samoa", currency: "WST" },
  { code: "SM", name: "San Marino", currency: "EUR" },
  { code: "SA", name: "Saudi Arabia", currency: "SAR" },
  { code: "SN", name: "Senegal", currency: "XOF" },
  { code: "RS", name: "Serbia", currency: "RSD" },
  { code: "SC", name: "Seychelles", currency: "SCR" },
  { code: "SL", name: "Sierra Leone", currency: "SLL" },
  { code: "SG", name: "Singapore", currency: "SGD" },
  { code: "SK", name: "Slovakia", currency: "EUR" },
  { code: "SI", name: "Slovenia", currency: "EUR" },
  { code: "SB", name: "Solomon Islands", currency: "AUD" },
  { code: "SO", name: "Somalia", currency: "SOS" },
  { code: "ZA", name: "South Africa", currency: "ZAR" },
  { code: "SS", name: "South Sudan", currency: "SSP" },
  { code: "ES", name: "Spain", currency: "EUR" },
  { code: "LK", name: "Sri Lanka", currency: "LKR" },
  { code: "SD", name: "Sudan", currency: "SDG" },
  { code: "SR", name: "Suriname", currency: "SRD" },
  { code: "SZ", name: "Sweden", currency: "SEK" },
  { code: "CH", name: "Switzerland", currency: "CHF" },
  { code: "SY", name: "Syria", currency: "SYP" },
  { code: "TW", name: "Taiwan", currency: "TWD" },
  { code: "TJ", name: "Tajikistan", currency: "TJS" },
  { code: "TZ", name: "Tanzania", currency: "TZS" },
  { code: "TH", name: "Thailand", currency: "THB" },
  { code: "TL", name: "Timor-Leste", currency: "USD" },
  { code: "TG", name: "Togo", currency: "XOF" },
  { code: "TK", name: "Tokelau", currency: "NZD" },
  { code: "TO", name: "Tonga", currency: "TOP" },
  { code: "TT", name: "Trinidad and Tobago", currency: "TTD" },
  { code: "TN", name: "Tunisia", currency: "TND" },
  { code: "TR", name: "Turkey", currency: "TRY" },
  { code: "TM", name: "Turkmenistan", currency: "TMT" },
  { code: "TV", name: "Tuvalu", currency: "AUD" },
  { code: "UG", name: "Uganda", currency: "UGX" },
  { code: "UA", name: "Ukraine", currency: "UAH" },
  { code: "AE", name: "United Arab Emirates", currency: "AED" },
  { code: "GB", name: "United Kingdom", currency: "GBP" },
  { code: "US", name: "United States", currency: "USD" },
  { code: "UY", name: "Uruguay", currency: "UYU" },
  { code: "UZ", name: "Uzbekistan", currency: "UZS" },
  { code: "VU", name: "Vanuatu", currency: "VUV" },
  { code: "VE", name: "Venezuela", currency: "VES" },
  { code: "VN", name: "Vietnam", currency: "VND" },
  { code: "YE", name: "Yemen", currency: "YER" },
  { code: "ZM", name: "Zambia", currency: "ZMW" },
  { code: "ZW", name: "Zimbabwe", currency: "ZWL" },
];

const codeWithCurrency = [
  { code: "AED", currency: "UAE Dirham" },
  { code: "AFN", currency: "Afghan Afghani" },
  { code: "ALL", currency: "Albanian Lek" },
  { code: "AMD", currency: "Armenian Dram" },
  { code: "ANG", currency: "Netherlands Antillian Guilder" },
  { code: "AOA", currency: "Angolan Kwanza" },
  { code: "ARS", currency: "Argentine Peso" },
  { code: "AUD", currency: "Australian Dollar" },
  { code: "AWG", currency: "Aruban Florin" },
  { code: "AZN", currency: "Azerbaijani Manat" },
  { code: "BAM", currency: "Bosnia and Herzegovina Convertible Mark" },
  { code: "BBD", currency: "Barbados Dollar" },
  { code: "BDT", currency: "Bangladeshi Taka" },
  { code: "BGN", currency: "Bulgarian Lev" },
  { code: "BHD", currency: "Bahraini Dinar" },
  { code: "BIF", currency: "Burundian Franc" },
  { code: "BMD", currency: "Bermudian Dollar" },
  { code: "BND", currency: "Brunei Dollar" },
  { code: "BOB", currency: "Bolivian Boliviano" },
  { code: "BRL", currency: "Brazilian Real" },
  { code: "BSD", currency: "Bahamian Dollar" },
  { code: "BTN", currency: "Bhutanese Ngultrum" },
  { code: "BWP", currency: "Botswana Pula" },
  { code: "BYN", currency: "Belarusian Ruble" },
  { code: "BZD", currency: "Belize Dollar" },
  { code: "CAD", currency: "Canadian Dollar" },
  { code: "CDF", currency: "Congolese Franc" },
  { code: "CHF", currency: "Swiss Franc" },
  { code: "CLP", currency: "Chilean Peso" },
  { code: "CNY", currency: "Chinese Renminbi" },
  { code: "COP", currency: "Colombian Peso" },
  { code: "CRC", currency: "Costa Rican Colon" },
  { code: "CUP", currency: "Cuban Peso" },
  { code: "CVE", currency: "Cape Verdean Escudo" },
  { code: "CZK", currency: "Czech Koruna" },
  { code: "DJF", currency: "Djiboutian Franc" },
  { code: "DKK", currency: "Danish Krone" },
  { code: "DOP", currency: "Dominican Peso" },
  { code: "DZD", currency: "Algerian Dinar" },
  { code: "EGP", currency: "Egyptian Pound" },
  { code: "ERN", currency: "Eritrean Nakfa" },
  { code: "ETB", currency: "Ethiopian Birr" },
  { code: "EUR", currency: "Euro" },
  { code: "FJD", currency: "Fiji Dollar" },
  { code: "FKP", currency: "Falkland Islands Pound" },
  { code: "FOK", currency: "Faroese Króna" },
  { code: "GBP", currency: "Pound Sterling" },
  { code: "GEL", currency: "Georgian Lari" },
  { code: "GGP", currency: "Guernsey Pound" },
  { code: "GHS", currency: "Ghanaian Cedi" },
  { code: "GIP", currency: "Gibraltar Pound" },
  { code: "GMD", currency: "Gambian Dalasi" },
  { code: "GNF", currency: "Guinean Franc" },
  { code: "GTQ", currency: "Guatemalan Quetzal" },
  { code: "GYD", currency: "Guyanese Dollar" },
  { code: "HKD", currency: "Hong Kong Dollar" },
  { code: "HNL", currency: "Honduran Lempira" },
  { code: "HRK", currency: "Croatian Kuna" },
  { code: "HTG", currency: "Haitian Gourde" },
  { code: "HUF", currency: "Hungarian Forint" },
  { code: "IDR", currency: "Indonesian Rupiah" },
  { code: "ILS", currency: "Israeli New Shekel" },
  { code: "IMP", currency: "Isle of Man Pound" },
  { code: "INR", currency: "Indian Rupee" },
  { code: "IQD", currency: "Iraqi Dinar" },
  { code: "IRR", currency: "Iranian Rial" },
  { code: "ISK", currency: "Icelandic Króna" },
  { code: "JMD", currency: "Jamaican Dollar" },
  { code: "JOD", currency: "Jordanian Dinar" },
  { code: "JPY", currency: "Japanese Yen" },
  { code: "KES", currency: "Kenyan Shilling" },
  { code: "KGS", currency: "Kyrgyzstani Som" },
  { code: "KHR", currency: "Cambodian Riel" },
  { code: "KMF", currency: "Comorian Franc" },
  { code: "KRW", currency: "South Korean Won" },
  { code: "KWD", currency: "Kuwaiti Dinar" },
  { code: "KYD", currency: "Cayman Islands Dollar" },
  { code: "KZT", currency: "Kazakhstani Tenge" },
  { code: "LAK", currency: "Lao Kip" },
  { code: "LBP", currency: "Lebanese Pound" },
  { code: "LKR", currency: "Sri Lankan Rupee" },
  { code: "LRD", currency: "Liberian Dollar" },
  { code: "LSL", currency: "Lesotho Loti" },
  { code: "LTL", currency: "Lithuanian Litas" },
  { code: "LVL", currency: "Latvian Lats" },
  { code: "LYD", currency: "Libyan Dinar" },
  { code: "MAD", currency: "Moroccan Dirham" },
  { code: "MDL", currency: "Moldovan Leu" },
  { code: "MGA", currency: "Malagasy Ariary" },
  { code: "MKD", currency: "Macedonian Denar" },
  { code: "MMK", currency: "Myanma Kyat" },
  { code: "MNT", currency: "Mongolian Tugrik" },
  { code: "MOP", currency: "Macanese Pataca" },
  { code: "MRU", currency: "Mauritanian Ouguiya" },
  { code: "MUR", currency: "Mauritian Rupee" },
  { code: "MVR", currency: "Maldivian Rufiyaa" },
  { code: "MWK", currency: "Malawian Kwacha" },
  { code: "MXN", currency: "Mexican Peso" },
  { code: "MYR", currency: "Malaysian Ringgit" },
  { code: "MZN", currency: "Mozambican Metical" },
  { code: "NAD", currency: "Namibian Dollar" },
  { code: "NGN", currency: "Nigerian Naira" },
  { code: "NIO", currency: "Nicaraguan Córdoba" },
  { code: "NOK", currency: "Norwegian Krone" },
  { code: "NPR", currency: "Nepalese Rupee" },
  { code: "NZD", currency: "New Zealand Dollar" },
  { code: "OMR", currency: "Omani Rial" },
  { code: "PAB", currency: "Panamanian Balboa" },
  { code: "PEN", currency: "Peruvian Nuevo Sol" },
  { code: "PGK", currency: "Papua New Guinean Kina" },
  { code: "PHP", currency: "Philippine Peso" },
  { code: "PKR", currency: "Pakistani Rupee" },
  { code: "PLN", currency: "Polish Zloty" },
  { code: "PYG", currency: "Paraguayan Guarani" },
  { code: "QAR", currency: "Qatari Rial" },
  { code: "RON", currency: "Romanian Leu" },
  { code: "RSD", currency: "Serbian Dinar" },
  { code: "RUB", currency: "Russian Ruble" },
  { code: "RWF", currency: "Rwandan Franc" },
  { code: "SAR", currency: "Saudi Riyal" },
  { code: "SBD", currency: "Solomon Islands Dollar" },
  { code: "SCR", currency: "Seychellois Rupee" },
  { code: "SDG", currency: "Sudanese Pound" },
  { code: "SEK", currency: "Swedish Krona" },
  { code: "SGD", currency: "Singapore Dollar" },
  { code: "SHP", currency: "Saint Helena Pound" },
  { code: "SLL", currency: "Sierra Leonean Leone" },
  { code: "SOS", currency: "Somali Shilling" },
  { code: "SPL", currency: "São Tomé and Príncipe Dobra" },
  { code: "SRD", currency: "Surinamese Dollar" },
  { code: "SSP", currency: "South Sudanese Pound" },
  { code: "STN", currency: "São Tomé and Príncipe Dobra" },
  { code: "SYP", currency: "Syrian Pound" },
  { code: "SZL", currency: "Swazi Lilangeni" },
  { code: "THB", currency: "Thai Baht" },
  { code: "TJS", currency: "Tajikistani Somoni" },
  { code: "TMT", currency: "Turkmenistani Manat" },
  { code: "TND", currency: "Tunisian Dinar" },
  { code: "TOP", currency: "Tongan Paʻanga" },
  { code: "TRY", currency: "Turkish Lira" },
  { code: "TTD", currency: "Trinidad and Tobago Dollar" },
  { code: "TWD", currency: "New Taiwan Dollar" },
  { code: "TZS", currency: "Tanzanian Shilling" },
  { code: "UAH", currency: "Ukrainian Hryvnia" },
  { code: "UGX", currency: "Ugandan Shilling" },
  { code: "USD", currency: "United States Dollar" },
  { code: "UYU", currency: "Uruguayan Peso" },
  { code: "UZS", currency: "Uzbekistani Som" },
  { code: "VEF", currency: "Venezuelan Bolívar" },
  { code: "VND", currency: "Vietnamese Dong" },
  { code: "VUV", currency: "Vanuatu Vatu" },
  { code: "WST", currency: "Samoan Tala" },
  { code: "XAF", currency: "CFA Franc BEAC" },
  { code: "XCD", currency: "East Caribbean Dollar" },
  { code: "XOF", currency: "CFA Franc West African" },
  { code: "XPF", currency: "CFP Franc" },
  { code: "YER", currency: "Yemeni Rial" },
  { code: "ZAR", currency: "South African Rand" },
  { code: "ZMW", currency: "Zambian Kwacha" },
  { code: "ZWL", currency: "Zimbabwean Dollar" }
];

const currencySymbols = {
  AED: "د.إ",
  AFN: "؋",
  ALL: "L",
  AMD: "֏",
  ANG: "ƒ",
  AOA: "Kz",
  ARS: "$",
  AUD: "A$",
  AWG: "ƒ",
  AZN: "₼",
  BAM: "KM",
  BBD: "Bds$",
  BDT: "৳",
  BGN: "лв",
  BHD: ".د.ب",
  BIF: "FBu",
  BMD: "$",
  BND: "B$",
  BOB: "Bs.",
  BRL: "R$",
  BSD: "$",
  BTN: "Nu.",
  BWP: "P",
  BYN: "Br",
  BZD: "BZ$",
  CAD: "C$",
  CDF: "FC",
  CHF: "CHF",
  CLP: "$",
  CNY: "¥",
  COP: "$",
  CRC: "₡",
  CUP: "$",
  CVE: "Esc",
  CZK: "Kč",
  DJF: "Fdj",
  DKK: "kr",
  DOP: "RD$",
  DZD: "د.ج",
  EGP: "E£",
  ERN: "Nfk",
  ETB: "Br",
  EUR: "€",
  FJD: "FJ$",
  FKP: "£",
  FOK: "kr",
  GBP: "£",
  GEL: "₾",
  GGP: "£",
  GHS: "₵",
  GIP: "£",
  GMD: "D",
  GNF: "FG",
  GTQ: "Q",
  GYD: "G$",
  HKD: "HK$",
  HNL: "L",
  HRK: "kn",
  HTG: "G",
  HUF: "Ft",
  IDR: "Rp",
  ILS: "₪",
  IMP: "£",
  INR: "₹",
  IQD: "ع.د",
  IRR: "﷼",
  ISK: "kr",
  JMD: "J$",
  JOD: "JD",
  JPY: "¥",
  KES: "KSh",
  KGS: "сом",
  KHR: "៛",
  KMF: "CF",
  KRW: "₩",
  KWD: "د.ك",
  KYD: "CI$",
  KZT: "₸",
  LAK: "₭",
  LBP: "ل.ل",
  LKR: "Rs",
  LRD: "L$",
  LSL: "L",
  LTL: "Lt",
  LVL: "Ls",
  LYD: "ل.د",
  MAD: "د.م.",
  MDL: "L",
  MGA: "Ar",
  MKD: "ден",
  MMK: "K",
  MNT: "₮",
  MOP: "MOP$",
  MRU: "UM",
  MUR: "₨",
  MVR: ".ރ",
  MWK: "MK",
  MXN: "Mex$",
  MYR: "RM",
  MZN: "MT",
  NAD: "N$",
  NGN: "₦",
  NIO: "C$",
  NOK: "kr",
  NPR: "₨",
  NZD: "NZ$",
  OMR: "﷼",
  PAB: "B/.",
  PEN: "S/.",
  PGK: "K",
  PHP: "₱",
  PKR: "₨",
  PLN: "zł",
  PYG: "₲",
  QAR: "﷼",
  RON: "lei",
  RSD: "дин.",
  RUB: "₽",
  RWF: "R₣",
  SAR: "﷼",
  SBD: "SI$",
  SCR: "₨",
  SDG: "ج.س.",
  SEK: "kr",
  SGD: "S$",
  SHP: "£",
  SLL: "Le",
  SOS: "S",
  SPL: "Db", // Obsolete, see STN
  SRD: "$",
  SSP: "£",
  STN: "Db",
  SYP: "S£",
  SZL: "E",
  THB: "฿",
  TJS: "SM",
  TMT: "T",
  TND: "د.ت",
  TOP: "T$",
  TRY: "₺",
  TTD: "TT$",
  TWD: "NT$",
  TZS: "TSh",
  UAH: "₴",
  UGX: "USh",
  USD: "$",
  UYU: "$U",
  UZS: "so'm",
  VEF: "Bs.", // Obsolete
  VES: "Bs.",
  VND: "₫",
  VUV: "VT",
  WST: "WS$",
  XAF: "FCFA",
  XCD: "EC$",
  XOF: "CFA",
  XPF: "₣",
  YER: "﷼",
  ZAR: "R",
  ZMW: "ZK",
  ZWL: "Z$",
};

const indianStates = [
  { code: "AP", name: "Andhra Pradesh" },
  { code: "AR", name: "Arunachal Pradesh" },
  { code: "AS", name: "Assam" },
  { code: "BR", name: "Bihar" },
  { code: "CT", name: "Chhattisgarh" },
  { code: "GA", name: "Goa" },
  { code: "GJ", name: "Gujarat" },
  { code: "HR", name: "Haryana" },
  { code: "HP", name: "Himachal Pradesh" },
  { code: "JH", name: "Jharkhand" },
  { code: "KA", name: "Karnataka" },
  { code: "KL", name: "Kerala" },
  { code: "MP", name: "Madhya Pradesh" },
  { code: "MH", name: "Maharashtra" },
  { code: "MN", name: "Manipur" },
  { code: "ML", name: "Meghalaya" },
  { code: "MZ", name: "Mizoram" },
  { code: "NL", name: "Nagaland" },
  { code: "OD", name: "Odisha" },
  { code: "PB", name: "Punjab" },
  { code: "RJ", name: "Rajasthan" },
  { code: "SK", name: "Sikkim" },
  { code: "TN", name: "Tamil Nadu" },
  { code: "TS", name: "Telangana" },
  { code: "TR", name: "Tripura" },
  { code: "UP", name: "Uttar Pradesh" },
  { code: "UK", name: "Uttarakhand" },
  { code: "WB", name: "West Bengal" }
];

const getCountryList = () => {
  return countriesWithCurrencies.map((el) => {
    return {
      label: el.name,
      value: el.name,
      code: el.code,
      currency: el.currency
    }
  });
};

const getCurrencyCode = (value) => {
  const selectedCurrency = countriesWithCurrencies.find(
    (country) => country.name == value
  );
  return selectedCurrency.currency;
};

const getCurrencyCodeWithName = () => {
  return codeWithCurrency;
}

const getCurrencySymbol = (currencyCode) => {
  return currencySymbols[currencyCode] || currencyCode; // fallback to code if symbol missing
};

const formatINRCompact = (value, decimals = 2) => {
  const num = Number(value) || 0;

  if (num >= 1e7) {
    return (num / 1e7).toFixed(decimals) + " Cr";
  }
  if (num >= 1e5) {
    return (num / 1e5).toFixed(decimals) + " L";
  }
  if (num >= 1e3) {
    return num.toLocaleString("en-IN");
  }

  return num.toFixed(decimals);
};

const formatAmountCompact = ({
  value = 0,
  country = "",
  decimals = 2,
}) => {
  const num = Number(value) || 0;
  const isIndia = country?.toLowerCase() === "india";

  // 🇮🇳 Indian system
  if (isIndia) {
    return formatINRCompact(num, decimals);
  }

  // 🌍 International system (GCC, US, EU, etc.)
  return new Intl.NumberFormat("en", {
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: decimals,
  }).format(num);
};

async function convertCurrency(fromCurrency, toCurrency) {
  const API_KEY = process.env.REACT_APP_EXCHANGE_RATE_API_KEY;
  const url = `https://v6.exchangerate-api.com/v6/${API_KEY}/pair/${fromCurrency}/${toCurrency}`;
  try {
    const response = await axios.get(url);
    const rate = response.data.conversion_rate;
    return rate;
  } catch (error) {
    console.error('Currency conversion error:', error.message);
    return null;
  }
}

// Map Country Name → ISO2 Code (lowercase for react-phone-input-2)
const getISOFromCountryName = (countryName) => {
  if (!countryName) return "us";
  const match = countriesWithCurrencies.find(
    (c) => c.name.toLowerCase().trim() === countryName.toLowerCase().trim()
  );
  return match ? match.code.toLowerCase() : "us"; // default fallback
};

const gstTypeOptions = [
  {
    label: "Regular",
    value: "regular",
  },
  {
    label: "Composition",
    value: "composition",
  },
  {
    label: "Unregistered",
    value: "unregistered",
  },
];


export {
  countriesWithCurrencies,
  getCountryList,
  getCurrencyCode,
  convertCurrency,
  getCurrencyCodeWithName,
  getCurrencySymbol,
  getISOFromCountryName,
  formatINRCompact,
  formatAmountCompact,
  indianStates,
  gstTypeOptions
};
